import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { Row } from "common/components";
import { Button } from "components/bootstrap";
import { IfPermitted, Spinner, ModalButtonToolbar } from "components/common";
function UserFormButtons({ isEditing, onCancel }) {
  const { isValid, dirty, isSubmitting, submitForm } = useFormikContext();
  const submitText = useMemo(
    () => (
      // eslint-disable-next-line no-nested-ternary
      isSubmitting ? isEditing ? "Saving..." : "Creating..." : isEditing ? "Save Asset" : "Create Asset"
    ),
    [isEditing, isSubmitting]
  );
  return /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "asset:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: submitForm, disabled: !isValid || !dirty || isSubmitting }, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, isSubmitting && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), submitText))));
}
export default UserFormButtons;
